(function() {
    'use strict';

    angular
        .module('am.date-picker', ['ngMaterial', 'ngAnimate']);
        
})();
